import {
  USER_START,
  USER_SUCCESS,
  USER_ERROR,
  USER_PROJECT_SUCCESS,
  USER_CLEAR,
} from './UserTypes';

const INITIAL_STATE = {
  loading: false,
  error: false,
  data: [],
  projectMembers: [],
};

export default (state: any = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case USER_START:
      return { ...state, loading: true, error: null };

    case USER_SUCCESS:
      return { ...state, data: action.payload, loading: false };

    case USER_PROJECT_SUCCESS:
      return { ...state, projectMembers: action.payload, loading: false };

    case USER_ERROR:
      return { ...state, loading: false, error: action.payload };

    case USER_CLEAR:
      return { ...state, data: [], loading: false };

    default:
      return state;
  }
};
